import React from "react";

/*
 * Contexte fournissant les métriques ISO estimées (temps/coût/retard/avance) par Dock réel, calculées
 * par notre lib et affichées sur l'écran /dispatch (dev-only) pour comparer d'un onglet à l'autre au
 * découpage de la lib. Valeur = { dock_id: { time_min, cost_eur, delay_min, wait_min, ... } }.
 */
export const DockEstimatesContext = React.createContext({});
